import {
  KeyboardArrowUp as KeyboardArrowUpIcon,
  KeyboardArrowDown as KeyboardArrowDownIcon,
} from "@mui/icons-material";
import { cloneDeep } from "lodash";
import React, { useState } from "react";
import { Button, Divider, Grid, TextField } from "@mui/material";

import SubmitButton from "components/Button/SubmitButton";
import EmptyContainer from "components/common/empty_container/EmptyContainer";

import PatientDiagnosisItem from "./PatientDiagnosisItem";
import usePatientHistoryInformation from "../usePatientHistoryInformation";

import { isValidArray } from "utils/array";

const PatientDiagnosis = ({ isEditMode }) => {
  const [isEditDiagnosis, setIsEditDiagnosis] = useState(false);
  const [currentDiagnosis, setCurrentDiagnosis] = useState({
    diagnosis: "",
    index: "",
  });
  const [toggleViewMore, setToggleViewMore] = useState(false);

  const { handleInputChange, newPatientHistoryInformation } =
    usePatientHistoryInformation();

  const handleDiagnosis = async (isDelete, diagnosis, index) => {
    let diagnosisList = [
      ...(newPatientHistoryInformation?.patientDiagnosis || []),
    ];

    if (isDelete) {
      diagnosisList = diagnosisList.filter(
        (diagnosisItem, diagnosisIndex) =>
          diagnosisItem !== diagnosis && diagnosisIndex !== index
      );
    } else {
      const { diagnosis: diagnosisData, index: diagnosisIndex } =
        currentDiagnosis;

      if (diagnosisIndex >= 0 && isEditDiagnosis) {
        diagnosisList[diagnosisIndex] = diagnosisData?.trim();
      } else {
        diagnosisList.unshift(diagnosisData?.trim());
      }
    }

    const copy = cloneDeep(newPatientHistoryInformation);
    copy.patientDiagnosis = diagnosisList;
    handleInputChange(copy);

    setCurrentDiagnosis({});
  };

  const visibleDiagnosis =
    newPatientHistoryInformation?.patientDiagnosis?.slice(0, 2);
  const nonVisibleDiagnosis =
    newPatientHistoryInformation?.patientDiagnosis?.slice(2);

  return isEditMode ? (
    <div style={{ width: "100%" }}>
      <div
        className="patient-form__info--header"
        style={{ color: "#175EC8", marginBottom: "4px" }}
      >
        PATIENT DIAGNOSIS
      </div>
      <Grid container spacing={1}>
        <Grid item xs={6}>
          <TextField
            value={currentDiagnosis?.diagnosis || ""}
            className="view-pdf__textarea mb-2"
            placeholder="Type here to add diagnosis"
            id="outlined-multiline-static"
            data-text="patient-diagnosis-field"
            multiline
            rows="6"
            fullWidth
            name="diagnosis"
            variant="outlined"
            onChange={(e) =>
              setCurrentDiagnosis({
                diagnosis: e.target.value,
                index: currentDiagnosis?.index,
              })
            }
          />
          <div style={{ textAlign: "right" }}>
            <SubmitButton
              className="ml-2"
              variant="contained"
              color="secondary"
              handleClick={() => handleDiagnosis(false)}
              disabled={!currentDiagnosis?.diagnosis?.trim()}
              buttonText="Add"
            />
          </div>
        </Grid>

        <Grid item xs={6}>
          <div className="patient-form__info--header" style={{ marginTop: 0 }}>
            Diagnosis Notes
          </div>

          <div>
            {!isValidArray(newPatientHistoryInformation?.patientDiagnosis) ? (
              <EmptyContainer
                height="120px"
                noDataText={<h3>No diagnosis data available.</h3>}
              />
            ) : (
              <>
                <div style={{ maxHeight: "120px", overflowY: "auto" }}>
                  {visibleDiagnosis?.map((diagnosis, index) => {
                    return (
                      <PatientDiagnosisItem
                        key={index}
                        index={index}
                        diagnosis={diagnosis}
                        isSelected={currentDiagnosis?.index === index}
                        handleDiagnosis={handleDiagnosis}
                        setCurrentDiagnosis={setCurrentDiagnosis}
                        setIsEditDiagnosis={setIsEditDiagnosis}
                      />
                    );
                  })}

                  {toggleViewMore &&
                    isValidArray(nonVisibleDiagnosis) &&
                    nonVisibleDiagnosis.map((diagnosis, index) => {
                      return (
                        <PatientDiagnosisItem
                          key={index}
                          index={index}
                          diagnosis={diagnosis}
                          isSelected={currentDiagnosis?.index === index}
                          handleDiagnosis={handleDiagnosis}
                          setCurrentDiagnosis={setCurrentDiagnosis}
                          setIsEditDiagnosis={setIsEditDiagnosis}
                        />
                      );
                    })}
                </div>

                {isValidArray(nonVisibleDiagnosis) && (
                  <div style={{ textAlign: "left" }}>
                    <Button
                      color="secondary"
                      variant="text"
                      onClick={() => setToggleViewMore((preState) => !preState)}
                      endIcon={
                        toggleViewMore ? (
                          <KeyboardArrowUpIcon />
                        ) : (
                          <KeyboardArrowDownIcon />
                        )
                      }
                    >
                      {toggleViewMore ? "View Less" : "View More"}
                    </Button>
                  </div>
                )}
              </>
            )}
          </div>
        </Grid>
      </Grid>

      <Divider className="mt-2 mb-2" />
    </div>
  ) : (
    <div className="patient-form__row">
      <div className="patient-form__info--header" style={{ color: "#175EC8" }}>
        PATIENT DIAGNOSIS
      </div>

      <div className="patient-form__info--header">Diagnosis Notes</div>

      <Grid container rowSpacing={2} className="view-pdf__drawer-grid">
        {!isValidArray(newPatientHistoryInformation?.patientDiagnosis) && (
          <div className="d-flex justify-center">
            No diagnosis data available.
          </div>
        )}

        {isValidArray(newPatientHistoryInformation?.patientDiagnosis) && (
          <ol type="1" style={{ marginLeft: "20px", marginBottom: "8px" }}>
            {newPatientHistoryInformation.patientDiagnosis?.map(
              (diagnosis, index) => (
                <li
                  key={`diagnosis-${index}`}
                  style={{ fontSize: "14px", fontWeight: 400 }}
                >
                  <span>{diagnosis?.trim() || "-"}</span>
                </li>
              )
            )}
          </ol>
        )}
      </Grid>
    </div>
  );
};

export default PatientDiagnosis;
